import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserIdleService } from 'angular-user-idle';
import { AuthService } from 'src/app/core/common/auth.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.css'],
})
export class ShellComponent implements OnInit {

  constructor(private userIdle: UserIdleService, private router: Router, private modalService: NgbModal,
    private _auth: AuthService,) { }

  ngOnInit() {
    //Start watching for user inactivity.
    this.userIdle.startWatching();
    // Start watching when user idle is starting.
    this.userIdle.onTimerStart().subscribe(count => { console.log('22', count) })
    this.userIdle.ping$.subscribe(() => {

    });
    // Start watch when time is up.this._auth.clearToken()
    this.userIdle.onTimeout().subscribe((c) => {
      this.logout()
    })
  }
  //  aler(){
  //     Swal.fire({
  //     title: 'Are you sure?',
  //     text: "You won't be able to revert this!",
  //     icon: 'warning',
  //     position: 'top',
  //     customClass:'swal-wide',
  //    showCancelButton: true,
  //     confirmButtonColor: '#3085d6',
  //     cancelButtonColor: '#d33',
  //     confirmButtonText: 'Yes, delete it!'
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //    this.logout()
  //     }
  //     else{
  //      this.userIdle.stopWatching();
  //       this.userIdle.resetTimer();
  //     }

  //   }) 
  //  }
  logout() {

    this.userIdle.stopWatching();
    this.userIdle.stopTimer()
    this._auth.clearToken()
  }


}
